// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".s-module__root--lM5sc {\n  flex-shrink: 0;\n  width: 420px;\n}\n.s-module__image--FphUi {\n  width: 420px;\n  height: auto;\n  display: block;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/dashboard/EFaxPage/EFaxLandingPage/HeroSendFaxPreview/s.module.less"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;AACF;AAEA;EACE,YAAA;EACA,YAAA;EACA,cAAA;AAAF","sourcesContent":[".root {\n  flex-shrink: 0;\n  width: 420px;\n}\n\n.image {\n  width: 420px;\n  height: auto;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "s-module__root--lM5sc",
	"image": "s-module__image--FphUi"
};
export default ___CSS_LOADER_EXPORT___;
